module.exports = __webpack_public_path__ + "img/acceleration_load_icon.ecf1aba9.png";